import {AfterViewInit, Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, AfterViewInit {

    faq: any[] = [];

    constructor() {
    }

    ngOnInit(): void {

        this.faq = [
            {
                title: 'According to the test result, my anxiety level is high. Could this mean that I’m suffering from a disorder?',
                texts: ['The test is not a diagnostic procedure but can detect the probability of you developing a disorder. If your test score is high and it is accompanied by problems that bother you, we recommend that you see a doctor, psychologist, or psychiatrist.']
            },
            {
                title: 'I get different results with each test. Does the test not work?',
                texts: [
                    'By taking the test, you will be able to determine the current level of anxiety that you are experiencing. This means that the results may change according to your current state of health.',
                    'If you see a drop in anxiety after engaging in regular physical activity or communicating with a therapist, this is a great sign!',
                    'Anima is a free-view test. Therefore, it is possible to inadvertently or consciously change the results if you adopt a new observation strategy. Try to pass the test without giving much thought to your behavior or reactions.'
                ]
            },

            {
                title: 'According to the test results, I have the lowest anxiety index but feel anxious. How is this possible?',
                texts: [
                    'If you struggle to find the words that adequately explain your anxiety, your condition may be difficult to diagnose using more conventional methods.',
                    'Your low score on the AAB test suggests that your anxiety is situational rather than based on your sensitivity to threatening stimuli.',
                    'The “technical sensitivity” of the Anima test requires that you strictly adhere to the technical rules of the test. Otherwise, it is possible to get inaccurate results.',
                    'If you believe that you did not take the test correctly, try retaking the test and be sure to carefully apply the on-screen suggestions.'
                ]
            },
            {
                title: 'I am on medication. Can this affect the test results?',
                texts: [
                    'Everything relies on what you consume. The majority of psychoactive substances have an impact on our mental state and response, which will affect the test findings.',
                    'Conversely, antidepressants and anxiolytics strengthen our overall health and self-esteem rather than jeopardize our reactions, which will also have an impact on the outcomes of conventional surveys.',
                    'If your outcomes have improved after taking medication, that’s a fantastic sign!'
                ]
            },
            {
                title: 'Can this test substitute for a visit to a doctor?',
                texts: [
                    'Anima is unable to provide a comprehensive diagnosis. It is not possible to get properly diagnosed without first speaking in person with a physician.',
                    'Anima is able to give you the trustworthy information you need in order to make an educated decision about which coping strategies to use or whether you should go see a doctor.'
                ]
            },
            {
                title: 'Previous test results were better than the new ones. Does this mean that my condition is getting worse?',
                texts: [
                    'In most cases, no. The anxiety levels that Anima measures are dynamic and may change at any time. A worse result could just mean something is bothering you at the time of the test.',
                    'But let’s say you’ve had a slew of tests that all point to a steady decline in your health while your anxiety symptoms have been increasing in intensity. In this case, we advise that you seek the help of a medical professional, a psychologist, or a psychiatrist.'
                ]
            },
            {
                title: 'Why is my anxiety high? Am I mentally ill?',
                texts: [
                    'The human response to danger is anxiety. Anxiety, in particular, triggers the survival instincts that allow us to fight, flee, and save ourselves.',
                    'Yet these defenses can reinforce one another, leading to feelings of anxiety even when there is no actual danger present. A visit to a physician, psychologist, or psychiatrist is advised if you experience severe distress from such a situation for longer than two weeks.',
                    'If you have high anxiety, don’t worry; you are not doomed! 50% of US adults will experience mental health issues at some point n their adult lives, and about 20% of US adults experience mental health problems in any given year. You are definitely not alone if you need to seek treatment.'
                ]
            },
            {
                title: 'Is there a way I can improve my results? And do I need my results to be “better”?',
                texts: [
                    'The number of elements that contribute to one’s level of anxiety is directly proportional to their level of anxiety.',
                    'If having a higher-than-average anxiety index feels like your normal condition, then it is not necessary for you to make any changes.',
                    'In the event that anxiety is making your life more challenging, the findings of the test will give recommendations on how to reduce the severity of your symptoms.'
                ]
            },
            {
                title: 'The AAB test does not work. How do you fix this?',
                texts: [
                    'The test depends on several important parameters:'
                ],
                list: [
                    'The test can only be taken on a laptop or PC; it is not designed for use on a tablet or smartphone.',
                    'In order to use an external camera, your device must already have one built in.',
                    'The website will need access to your camera.',
                    'The Google Chrome web browser is recommended.',
                    'If you have an eye condition (eye trauma, keratoconus, pathological nystagmus, etc.), it can impact the test significantly.',
                    'There could have been an error during the calibration process. Try the test again.',
                    'If the page lags or loads too slowly, try checking the quality of the Internet connection, or restart your device.',
                    'The camera must be positioned 12 to 24 inches from your pupils (you should be able to see them on the screen), and it must be able to capture your face fully. Place the camera at or below eye level.',
                    'Your face must be properly lighted. Change your position if it’s not.',
                    'If you are wearing glasses, make sure there is no glare from lighting obstructing the camera’s view of your eyes. Sometimes, lenses have in-built filters that reflect light from a screen or lamp, which might prevent the system from recognizing your eye movements. If this is the case, try changing the screen or camera position to avoid glare reflecting on your pupils.',
                    'There must be no other faces or face images in the frame.'
                ]
            },
            {
                title: 'Is there something I can do during the eye-tracking procedure to ensure a credible result?',
                texts: [],
                list: [
                    'Make sure you are positioned firmly during the test (your chair or the surface your gadget is placed on should remain still). If there is visible vibration or movement on camera, try changing your location.',
                    'Once the test starts, try not to change your head and body position.',
                    'Look for a place with stable lighting that covers your face evenly and won’t change during the test.'
                ]
            }
        ];
        const fU = [
            {
                title: 'According to the test result, my anxiety level is high. Could this mean that I’m suffering from a disorder?',
                texts: ['The test is not a diagnostic procedure but can detect the probability of you developing a disorder. If your test score is high and it is accompanied by problems that bother you, we recommend that you see a doctor, psychologist, or psychiatrist.']
            },
            {
                title: 'I get different results with each test. Does the test not work?',
                texts: [
                    'By taking the test, you will be able to determine the current level of anxiety that you are experiencing. This means that the results may change according to your current state of health.',
                    'If you see a drop in anxiety after engaging in regular physical activity or communicating with a therapist, this is a great sign!',
                    'Anima is a free-view test. Therefore, it is possible to inadvertently or consciously change the results if you adopt a new observation strategy. Try to pass the test without giving much thought to your behavior or reactions.'
                ]
            },

            {
                title: 'According to the test results, I have the lowest anxiety index but feel anxious. How is this possible?',
                texts: [
                    'If you struggle to find the words that adequately explain your anxiety, your condition may be difficult to diagnose using more conventional methods.',
                    'Your low score on the AAB test suggests that your anxiety is situational rather than based on your sensitivity to threatening stimuli.',
                    'The “technical sensitivity” of the Anima test requires that you strictly adhere to the technical rules of the test. Otherwise, it is possible to get inaccurate results.',
                    'If you believe that you did not take the test correctly, try retaking the test and be sure to carefully apply the on-screen suggestions.'
                ]
            },
            {
                title: 'I am on medication. Can this affect the test results?',
                texts: [
                    'Everything relies on what you consume. The majority of psychoactive substances have an impact on our mental state and response, which will affect the test findings.',
                    'Conversely, antidepressants and anxiolytics strengthen our overall health and self-esteem rather than jeopardize our reactions, which will also have an impact on the outcomes of conventional surveys.',
                    'If your outcomes have improved after taking medication, that’s a fantastic sign!'
                ]
            },
            {
                title: 'Can this test substitute for a visit to a doctor?',
                texts: [
                    'Anima is unable to provide a comprehensive diagnosis. It is not possible to get properly diagnosed without first speaking in person with a physician.',
                    'Anima is able to give you the trustworthy information you need in order to make an educated decision about which coping strategies to use or whether you should go see a doctor.'
                ]
            },
            {
                title: 'Previous test results were better than the new ones. Does this mean that my condition is getting worse?',
                texts: [
                    'In most cases, no. The anxiety levels that Anima measures are dynamic and may change at any time. A worse result could just mean something is bothering you at the time of the test.',
                    'But let’s say you’ve had a slew of tests that all point to a steady decline in your health while your anxiety symptoms have been increasing in intensity. In this case, we advise that you seek the help of a medical professional, a psychologist, or a psychiatrist.'
                ]
            },
            {
                title: 'Why is my anxiety high? Am I mentally ill?',
                texts: [
                    'The human response to danger is anxiety. Anxiety, in particular, triggers the survival instincts that allow us to fight, flee, and save ourselves.',
                    'Yet these defenses can reinforce one another, leading to feelings of anxiety even when there is no actual danger present. A visit to a physician, psychologist, or psychiatrist is advised if you experience severe distress from such a situation for longer than two weeks.',
                    'If you have high anxiety, don’t worry; you are not doomed! 50% of US adults will experience mental health issues at some point n their adult lives, and about 20% of US adults experience mental health problems in any given year. You are definitely not alone if you need to seek treatment.'
                ]
            },
            {
                title: 'Is there a way I can improve my results? And do I need my results to be “better”?',
                texts: [
                    'The number of elements that contribute to one’s level of anxiety is directly proportional to their level of anxiety.',
                    'If having a higher-than-average anxiety index feels like your normal condition, then it is not necessary for you to make any changes.',
                    'In the event that anxiety is making your life more challenging, the findings of the test will give recommendations on how to reduce the severity of your symptoms.'
                ]
            },
            {
                title: 'The AAB test does not work. How do you fix this?',
                texts: [
                    'The test depends on several important parameters:'
                ],
                list: [
                    'The test can only be taken on a laptop or PC; it is not designed for use on a tablet or smartphone.',
                    'In order to use an external camera, your device must already have one built in.',
                    'The website will need access to your camera.',
                    'The Google Chrome web browser is recommended.',
                    'If you have an eye condition (eye trauma, keratoconus, pathological nystagmus, etc.), it can impact the test significantly.',
                    'There could have been an error during the calibration process. Try the test again.',
                    'If the page lags or loads too slowly, try checking the quality of the Internet connection, or restart your device.',
                    'The camera must be positioned 12 to 24 inches from your pupils (you should be able to see them on the screen), and it must be able to capture your face fully. Place the camera at or below eye level.',
                    'Your face must be properly lighted. Change your position if it’s not.',
                    'If you are wearing glasses, make sure there is no glare from lighting obstructing the camera’s view of your eyes. Sometimes, lenses have in-built filters that reflect light from a screen or lamp, which might prevent the system from recognizing your eye movements. If this is the case, try changing the screen or camera position to avoid glare reflecting on your pupils.',
                    'There must be no other faces or face images in the frame.'
                ]
            },
            {
                title: 'Is there something I can do during the eye-tracking procedure to ensure a credible result?',
                texts: [],
                list: [
                    'Make sure you are positioned firmly during the test (your chair or the surface your gadget is placed on should remain still). If there is visible vibration or movement on camera, try changing your location.',
                    'Once the test starts, try not to change your head and body position.',
                    'Look for a place with stable lighting that covers your face evenly and won’t change during the test.'
                ]
            }
        ];

        const j = this.faq.map((el => {
            const texts = {};
            const list = {};
            if (el.texts && el.texts.length) {
                el.texts.forEach(text => {
                    return texts[text] = text;
                });
            }
            if (el.list && el.list.length) {
                el.list.forEach(text => {
                    return list[text] = text;
                });
            }
            const res = {
                [el.title]: el.title,
                ...texts,
                ...list
            };
            return res;
        }));

        // console.log(j);
    }

    ngAfterViewInit() {

    }

}
